var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    minHeight: '100vh',
    backgroundColor: _vm.$store.state.fastPersonalizacao.aluno_background_color ? _vm.$store.state.fastPersonalizacao.aluno_background_color : '#fff',
  })},[_c(_vm.FastLoading,{tag:"component"}),_c(_vm.HomeInternoHeader,{tag:"component"}),_c('transition',{attrs:{"name":"fast-fade"}},[_c(_vm.HomeInternoContent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }